import { AppointmentRepository } from '@/core/appointment/domain/AppointmentRepository.ts'
import { Appointment } from '@/core/appointment/domain/Appointment.ts'

type GetAppointmentUseCaseDependencies = { appointmentRepository: AppointmentRepository }

export class GetAppointmentUseCase {
  private readonly appointmentRepository: AppointmentRepository
  constructor({ appointmentRepository }: GetAppointmentUseCaseDependencies) {
    this.appointmentRepository = appointmentRepository
  }

  execute = (hostId: string, enterpriseId: string, id: string): Promise<Appointment> => {
    return this.appointmentRepository.getAppointment(hostId, enterpriseId, id)
  }
}
